import { render, staticRenderFns } from "./LeadPersonalDetails.vue?vue&type=template&id=31c8f02a&scoped=true&"
import script from "./LeadPersonalDetails.vue?vue&type=script&lang=js&"
export * from "./LeadPersonalDetails.vue?vue&type=script&lang=js&"
import style0 from "./LeadPersonalDetails.vue?vue&type=style&index=0&id=31c8f02a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c8f02a",
  null
  
)

export default component.exports